export function ucFirst( string ){

    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function ucWords( str ){

    return str
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('-');
}

export function getCouponLabel(discount){
    return `${discount}% OFF`
}

export function getShopTheLookUrl(url) {
    if(typeof url === 'string'){
        const [path, queryString] = url?.split('?');
        
        const query = {};
        
        if (queryString) {
            const queryParams = queryString.split('&');
            
            queryParams.forEach(param => {
                const [key, value] = param.split('=');
                
                query[key] = value;
            });

            query['RefreshKey'] = 'all'
        }
        
        return {
            path,
            query
        };
    }
}
